// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton-styles_button__2VAW5","dark":"IconButton-styles_dark__1CXAZ","headerButton":"IconButton-styles_headerButton__4-ddb","icon":"IconButton-styles_icon__G-TAW"};